import styled from 'styled-components'

export default styled.i`
    ${({ open }) => open && 'transform: rotate(180deg)'}
`
